import React from 'react';
import { MessageCircle } from 'lucide-react';

const WhatsappChat = () => {
  return (
    <a
      href="https://wa.me/919973923399"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-2xl transition-all transform hover:scale-110 flex items-center justify-center border-4 border-white group"
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle className="w-8 h-8 fill-current" />
    </a>
  );
};

export default WhatsappChat;
